<template>
  <section class="contrainer">
    <servicesInner translationKey="services.palletStorage" imgLink="palletInner" />
    <DescriptiveSection />
    <ProductVariety />
    <DiffStorage translationKey="how_it_works.storage_options" />
    <QualityCard />
    <div class="contactUs">
      <ContactUsCard translationKey="Let's have a conversation" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.contactUs {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



<script >
import servicesInner from "@/components/servicesInner/ServicesInner.vue";
import DescriptiveSection from "@/components/servicesInner/DescriptiveSection.vue";
import ProductVariety from "@/components/servicesInner/ProductVariety.vue";
import DiffStorage from "@/components/servicesInner/DiffStorage.vue";
import QualityCard from "@/components/servicesInner/Quality.vue";
import ContactUsCard from "@/components/global/ContactUsCard.vue";

export default {
  name: "PalletStorage",
  layout: "website_v3_layout",
  components: {
    servicesInner,
    DescriptiveSection,
    ProductVariety,
    DiffStorage,
    QualityCard,
    ContactUsCard
  },
  head() {
    var title = this.$t('seo.pallet_storage_page.title').toString();
    var description = this.$t('seo.pallet_storage_page.description').toString();
    var keywords = this.$t('seo.pallet_storage_page.keywords').toString();
    return {
      title: title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: description,
        },
        { hid: 'keywords', name: 'keywords', content: keywords },
        { hid: "facebook-title", property: "og:title", content: title },
        {
          hid: "facebook-description",
          property: "og:descrition",
          content: description,
        },
        { hid: "twitter-title", name: "twitter:title", content: title },
        {
          hid: "twitter-description",
          name: "twitter:description",
          content: description,
        },
      ],
    };
  },
} 
</script>
